/**
 * The blue `Manual` badge: the agent's own account, not a Cofactor-verified
 * pass. Shared by the criterion header and manual evidence rows so they never drift.
 *
 * @module features/proofs/components/ManualBadge
 */
import React from 'react';
import { Badge } from '@chatsdet/ui';
import type { ProofCriterion } from '../types';

export const ManualBadge: React.FC<{ status: ProofCriterion['status']; testId: string }> = ({ status, testId }) => (
  <Badge variant="default" size="sm" data-testid={testId}>
    {status.kind === 'stale' ? 'Manual · stale' : 'Manual'}
  </Badge>
);
